import styled from 'styled-components'

export const TextFooter = styled.div`
  color: var(--shape);
  font-size: 0.875rem;
  font-weight: 400;
`
